import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { MutationKeys } from "constants/mutation-keys";
import { ToastContent, getToastContent } from "constants/toasts";
import { ApiManager } from "services/api";
import { ITextEnhancements, TextEnhancement } from "store/entities/enhancements/interfaces";
import { ToastVariant, ToastsActions } from "store/features/toasts";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useTextEnhancers = (onSuccessCallback?: (text: string) => void) => {
  const dispatch = useDispatch();

  return useMutation({
    // @ts-expect-error TS(2769)
    mutationKey: [MutationKeys.TextEnhancement],
    mutationFn: async (payload: ITextEnhancements) => {
      const { input, action } = payload;
      const { result, error } = await ApiManager.textEnhancersApi.fetchEnhancement({
        input,
        action,
      });
      if (error) {
        if (action === TextEnhancement.CORRECT_GRAMMAR)
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Error,
              content: getToastContent(ToastContent.AI_TEXT_CORRECT_ENHANCEMENT_FAILURE),
            })
          );
        else if (action === TextEnhancement.MORE_ELABORATE) {
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Error,
              content: getToastContent(ToastContent.AI_TEXT_EXPAND_ENHANCEMENT_FAILURE),
            })
          );
        } else {
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Error,
              content: getToastContent(ToastContent.AI_TEXT_ADUST_ENHANCEMENT_FAILURE),
            })
          );
        }
      }

      return result;
    },
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess: (data: { text: string }, variables: any) => {
      if (data?.text) {
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        onSuccessCallback(data?.text);
        if (variables?.action === TextEnhancement.CORRECT_GRAMMAR)
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Success,
              content: getToastContent(ToastContent.AI_TEXT_CORRECT_ENHANCEMENT_SUCCESS),
            })
          );
        else if (variables?.action === TextEnhancement.MORE_ELABORATE) {
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Success,
              content: getToastContent(ToastContent.AI_TEXT_EXPAND_ENHANCEMENT_SUCCESS),
            })
          );
        } else {
          dispatch(
            ToastsActions.createToast({
              variant: ToastVariant.Success,
              content: getToastContent(ToastContent.AI_TEXT_ADUST_ENHANCEMENT_SUCCESS),
            })
          );
        }
      }
    },
  });
};
